import { Injectable } from '@angular/core';

/**
 * Konfiguriert das Verhalten der Prompt-Eingabeleiste (`RAGAI.PROMPTBAR`).
 * @remarks
 * `promptBarBehavior` steuert, was passiert, wenn der Nutzer in der Eingabeleiste Enter drückt:
 * `"runMessage"` (Standard) löst wie `RAGAI.MSG.prompt()` einen vollständigen KI-Antwort-Run aus,
 * `"userMessage"` fügt die Eingabe nur sichtbar zum Verlauf hinzu, ohne den Bot antworten zu lassen.
 */
@Injectable({ providedIn: 'root' })
export class PromptbarManagerService {

  public promptBarBehavior: "runMessage" | "userMessage" = 'runMessage';
}
